module.exports = __webpack_public_path__ + "img/jjfa_jdsfcb.dd04efe9.png";